// extracted by mini-css-extract-plugin
export default {"container":"delete-confirm_container__qbG6+"};